import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalDate } from '@js-joda/core';
import {DocumentFilter} from '../filter/document.filter';

@Injectable({
  providedIn: 'root'
})
export class GtiService {
  private SERVER_URL = '/api/t/{tenant}/gti';

  constructor(private httpClient: HttpClient) {}

  sync(filters: DocumentFilter): Observable<any> {
    return this.httpClient.post<void>(`${this.SERVER_URL}/sync`, JSON.stringify(filters));
  }
}
